<section class="mx-auto w-full max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
  <div class="mb-5 flex flex-wrap items-center justify-between gap-3">
    <div>
      <h1 class="text-2xl font-semibold text-slate-900">
        Sedes de {{ empresaNombre }}
      </h1>
      <p class="text-sm text-slate-500">
        Administra series y correlativos por cada sede.
      </p>
    </div>
    <div class="flex gap-2">
      <a
        class="inline-flex items-center gap-1 rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-700 transition hover:bg-slate-50"
        routerLink="/dashboard/empresas"
      >
        <i class="bi bi-arrow-left"></i> Volver
      </a>
      <button
        class="inline-flex items-center gap-1 rounded-lg bg-slate-900 px-3 py-2 text-sm font-medium text-white transition hover:bg-slate-700"
        (click)="openCreateModal(modalFormulario)"
      >
        <i class="bi bi-plus-circle"></i> Nueva sede
      </button>
    </div>
  </div>

  @if (loading) {
    <div class="flex items-center justify-center gap-2 py-12">
      <div
        class="h-5 w-5 animate-spin rounded-full border-2 border-slate-300 border-t-sky-600"
      ></div>
      <span class="text-sm text-slate-500">Cargando sedes...</span>
    </div>
  }

  @if (error && !loading) {
    <div
      class="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700"
      role="alert"
    >
      {{ error }}
    </div>
  }

  @if (!loading && !error) {
    <div
      class="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
    >
      <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-slate-200 text-sm">
          <thead class="bg-slate-50">
            <tr>
              <th class="px-4 py-3 text-left font-semibold text-slate-600">
                Sede
              </th>
              <th class="px-4 py-3 text-left font-semibold text-slate-600">
                Código
              </th>
              <th class="px-4 py-3 text-left font-semibold text-slate-600">
                Series
              </th>
              <th class="px-4 py-3 text-left font-semibold text-slate-600">
                Correlativos
              </th>
              <th class="px-4 py-3 text-left font-semibold text-slate-600">
                Estado
              </th>
              <th class="px-4 py-3 text-right font-semibold text-slate-600">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-200 bg-white">
            @for (sucursal of sucursales; track sucursal.id) {
              <tr class="hover:bg-slate-50">
                <td class="px-4 py-3">
                  <div class="font-semibold text-slate-900">
                    {{ sucursal.nombre }}
                  </div>
                  <small class="text-xs text-slate-500">{{
                    sucursal.direccion || "Sin direccion"
                  }}</small>
                </td>
                <td class="px-4 py-3 text-slate-700">{{ sucursal.codigo }}</td>
                <td class="px-4 py-3 text-xs text-slate-700">
                  <div>B: {{ sucursal.serie_boleta }}</div>
                  <div>F: {{ sucursal.serie_factura }}</div>
                  <div>NV: {{ sucursal.serie_nota_venta }}</div>
                </td>
                <td class="px-4 py-3 text-xs text-slate-700">
                  <div>B: {{ sucursal.correlativo_boleta }}</div>
                  <div>F: {{ sucursal.correlativo_factura }}</div>
                  <div>NV: {{ sucursal.correlativo_nota_venta }}</div>
                </td>
                <td class="px-4 py-3">
                  <div class="flex flex-wrap gap-1">
                    @if (sucursal.es_principal) {
                      <span
                        class="rounded-full bg-sky-100 px-2 py-0.5 text-xs font-medium text-sky-700"
                        >Principal</span
                      >
                    }
                    @if (sucursal.activo) {
                      <span
                        class="rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-medium text-emerald-700"
                        >Activa</span
                      >
                    } @else {
                      <span
                        class="rounded-full bg-slate-200 px-2 py-0.5 text-xs font-medium text-slate-700"
                        >Inactiva</span
                      >
                    }
                  </div>
                </td>
                <td class="px-4 py-3 text-right">
                  <div class="inline-flex gap-2">
                    <input
                      #excelInput
                      type="file"
                      class="hidden"
                      accept=".xlsx,.xls"
                      (change)="onExcelSelected($event, sucursal)"
                    />
                    <button
                      class="rounded-lg border border-emerald-300 px-2.5 py-1.5 text-emerald-700 transition hover:bg-emerald-50 disabled:cursor-not-allowed disabled:opacity-60"
                      [disabled]="importandoSucursalId === sucursal.id"
                      (click)="excelInput.click()"
                      title="Importar productos desde Excel"
                    >
                      @if (importandoSucursalId === sucursal.id) {
                        <i class="bi bi-arrow-repeat animate-spin"></i>
                      } @else {
                        <i class="bi bi-file-earmark-excel"></i>
                      }
                    </button>
                    <button
                      class="rounded-lg border border-sky-300 px-2.5 py-1.5 text-sky-700 transition hover:bg-sky-50"
                      (click)="openTelefonoModal(sucursal, modalTelefonos)"
                      title="Manejar teléfonos de la sede"
                    >
                      <i class="bi bi-telephone"></i>
                    </button>
                    <button
                      class="rounded-lg border border-sky-300 px-2.5 py-1.5 text-sky-700 transition hover:bg-sky-50"
                      (click)="openEditModal(sucursal, modalFormulario)"
                    >
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button
                      class="rounded-lg border border-red-300 px-2.5 py-1.5 text-red-700 transition hover:bg-red-50"
                      (click)="openDeleteModal(sucursal, modalEliminarSucursal)"
                    >
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            }

            @if (sucursales.length === 0) {
              <tr>
                <td
                  colspan="6"
                  class="px-4 py-12 text-center text-sm text-slate-500"
                >
                  No hay sedes registradas para esta empresa.
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</section>

<ng-template #modalFormulario let-modal>
  <div class="p-5">
    <div class="mb-4 flex items-center justify-between">
      <h5 class="text-lg font-semibold text-slate-900">
        {{ editingSucursal ? "Editar sede" : "Nueva sede" }}
      </h5>
      <button
        type="button"
        class="rounded-lg border border-slate-300 px-2 py-1 text-slate-600"
        (click)="modal.dismiss('cross-click')"
      >
        <i class="bi bi-x"></i>
      </button>
    </div>

    <div class="grid gap-3 md:grid-cols-12">
      <div class="md:col-span-6">
        <label class="mb-1 block text-sm font-medium text-slate-700"
          >Nombre *</label
        >
        <input
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
          [(ngModel)]="form.nombre"
        />
      </div>
      <div class="md:col-span-6">
        <label class="mb-1 block text-sm font-medium text-slate-700"
          >Código *</label
        >
        <input
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
          [(ngModel)]="form.codigo"
        />
      </div>
      <div class="md:col-span-6">
        <label class="mb-1 block text-sm font-medium text-slate-700"
          >Dirección</label
        >
        <input
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
          [(ngModel)]="form.direccion"
        />
      </div>
      <div class="md:col-span-3">
        <label class="mb-1 block text-sm font-medium text-slate-700"
          >Teléfono</label
        >
        <input
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
          [(ngModel)]="form.telefono"
        />
      </div>
      <div class="md:col-span-3">
        <label class="mb-1 block text-sm font-medium text-slate-700"
          >Email</label
        >
        <input
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
          [(ngModel)]="form.email"
        />
      </div>
    </div>

    <div class="my-4 border-t border-slate-200 pt-4">
      <h6 class="mb-3 text-sm font-semibold text-slate-800">
        Series y Correlativos
      </h6>
      <div class="grid gap-3 md:grid-cols-12">
        <div class="md:col-span-3">
          <label class="mb-1 block text-xs text-slate-600">Serie boleta</label
          ><input
            class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
            [(ngModel)]="form.serie_boleta"
          />
        </div>
        <div class="md:col-span-3">
          <label class="mb-1 block text-xs text-slate-600"
            >Correlativo boleta</label
          ><input
            type="number"
            class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
            [(ngModel)]="form.correlativo_boleta"
          />
        </div>
        <div class="md:col-span-3">
          <label class="mb-1 block text-xs text-slate-600">Serie factura</label
          ><input
            class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
            [(ngModel)]="form.serie_factura"
          />
        </div>
        <div class="md:col-span-3">
          <label class="mb-1 block text-xs text-slate-600"
            >Correlativo factura</label
          ><input
            type="number"
            class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
            [(ngModel)]="form.correlativo_factura"
          />
        </div>
        <div class="md:col-span-3">
          <label class="mb-1 block text-xs text-slate-600"
            >Serie nota venta</label
          ><input
            class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
            [(ngModel)]="form.serie_nota_venta"
          />
        </div>
        <div class="md:col-span-3">
          <label class="mb-1 block text-xs text-slate-600"
            >Correlativo nota venta</label
          ><input
            type="number"
            class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
            [(ngModel)]="form.correlativo_nota_venta"
          />
        </div>
        <div class="md:col-span-3">
          <label class="mb-1 block text-xs text-slate-600"
            >Serie nota crédito</label
          ><input
            class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
            [(ngModel)]="form.serie_nota_credito"
          />
        </div>
        <div class="md:col-span-3">
          <label class="mb-1 block text-xs text-slate-600"
            >Correlativo nota crédito</label
          ><input
            type="number"
            class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
            [(ngModel)]="form.correlativo_nota_credito"
          />
        </div>
      </div>
    </div>
    <div class="mb-4 flex flex-wrap gap-5">
      <label class="inline-flex items-center gap-2 text-sm text-slate-700">
        <input
          id="activo"
          type="checkbox"
          class="h-4 w-4 rounded border-slate-300"
          [(ngModel)]="form.activo"
        />
        Sede activa
      </label>
      <label class="inline-flex items-center gap-2 text-sm text-slate-700">
        <input
          id="es_principal"
          type="checkbox"
          class="h-4 w-4 rounded border-slate-300"
          [(ngModel)]="form.es_principal"
        />
        Marcar como principal
      </label>
    </div>

    <div class="flex justify-end gap-2">
      <button
        class="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700"
        (click)="modal.dismiss('cancel')"
      >
        Cancelar
      </button>
      <button
        class="rounded-lg bg-slate-900 px-3 py-2 text-sm font-medium text-white"
        (click)="saveSucursal(modal)"
      >
        Guardar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #modalEliminarSucursal let-modal>
  <div class="p-5">
    <div class="mb-4 flex items-center justify-between">
      <h5 class="text-lg font-semibold text-slate-900">Eliminar sede</h5>
      <button
        type="button"
        class="rounded-lg border border-slate-300 px-2 py-1 text-slate-600"
        (click)="modal.dismiss('cross-click')"
      >
        <i class="bi bi-x"></i>
      </button>
    </div>

    <div class="space-y-2 text-sm text-slate-700">
      <p>¿Está seguro que desea eliminar esta sede?</p>
      <p class="font-semibold text-slate-900">{{ deletingSucursal?.nombre }}</p>
      <p>Esta acción no se puede deshacer.</p>
    </div>

    <div class="mt-5 flex justify-end gap-2">
      <button
        class="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700"
        (click)="modal.dismiss('cancel')"
      >
        Cancelar
      </button>
      <button
        class="rounded-lg bg-red-600 px-3 py-2 text-sm font-medium text-white"
        (click)="removeSucursal(modal)"
      >
        Eliminar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #modalTelefonos let-modal>
  @if (editingSucursal != null) {
    <app-telefonos [sucursal]="editingSucursal!" (cerrar)="closeModal()" />
  }
</ng-template>

<app-toast aria-live="polite" aria-atomic="true"></app-toast>
